// src/api/investigationsService.ts
import apiClient from './config';
import { InvestigationData } from '../types/interfaces';

export const getInvestigations = async (): Promise<InvestigationData[]> => {
  try {
    const response = await apiClient.get('/investigations');
    
    return response.data.map((investigation: any) => ({
      id: investigation.id,
      user_id: investigation.user_id,
      created_at: investigation.created_at || '',
      company_name: investigation.company_name || '',
      comments: investigation.comments || '',
      status: investigation.status || 'pending',
      domains: investigation.domains || [],
      urls: investigation.urls || [],
      logo_url: investigation.logo_url || ''
    }));
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};


export const createInvestigation = async (company_name: string, comments: string, domains: string[], urls: string[]) => {
  try {
    const response = await apiClient.post('/investigations', {
      company_name,
      comments,
      domains,
      urls,
    });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};


export const deleteInvestigation = async (investigationId: string) => {
  try {
    await apiClient.delete(`/investigations/${investigationId}`);
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};

export const updateInvestigation = async (investigationId: string, data: Partial<InvestigationData>) => {
  try {
    const response = await apiClient.put(`/investigations/${investigationId}`, data);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};